<div class="header-dialog">
  <div *ngIf="data.mode == 'add'" class="titre">
    <mat-icon fontIcon="add"></mat-icon>
    <span>{{'planning.addPlanning'|translate}}</span>
  </div>

  <div *ngIf="data.mode == 'edit'" class="titre">
    <mat-icon fontIcon="edit"></mat-icon>
    <span>{{'planning.editPlanning'|translate}}</span>
  </div>

  <div *ngIf="data.mode == 'duplicate'" class="titre">
    <mat-icon fontIcon="content_copy"></mat-icon>
    <span>{{'planning.duplicatePlanning'|translate}}</span>
  </div>

  <lib-button (click)="close()" icon="close" color="none" textColor="muted">
    <mat-icon>close</mat-icon>
  </lib-button>
</div>

<form class="planning-form" (submit)="savePlanning()">

  <div class="form-column">
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>
        {{'form.name'|translate}}
      </mat-label>

      <input type="text" aria-label="text" matInput [(ngModel)]="planning.name" name="name">
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>
        {{'units.unit' | translate}}
      </mat-label>

      <mat-select [(ngModel)]="planning.unit" name="units">
        <mat-option [value]="unit.id" *ngFor="let unit of units">{{unit.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>{{'viewer.model' | translate}}</mat-label>
      <mat-select [(ngModel)]="planning.model" name="models">
        <!-- <mat-option [value]="null">{{"form.none"|translate}}</mat-option> -->
        <mat-option [value]="model.id" *ngFor="let model of models">{{model.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-checkbox [(ngModel)]="planning.auto" name="auto">
      {{'planning.auto' | translate}}</mat-checkbox>
  </div>

  <mat-dialog-actions class="actions">
    <lib-button (click)="close()" color="outline" icon="close" text="{{'viewer.close'|translate}}">
    </lib-button>

    <lib-button color="primary" text="{{'viewer.save'|translate}}" type="submit" icon="save">
    </lib-button>
  </mat-dialog-actions>
</form>